import { render, staticRenderFns } from "./founderProfileCard.vue?vue&type=template&id=3312c812&scoped=true&"
import script from "./founderProfileCard.vue?vue&type=script&lang=js&"
export * from "./founderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./founderProfileCard.vue?vue&type=style&index=0&id=3312c812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3312c812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3312c812')) {
      api.createRecord('3312c812', component.options)
    } else {
      api.reload('3312c812', component.options)
    }
    module.hot.accept("./founderProfileCard.vue?vue&type=template&id=3312c812&scoped=true&", function () {
      api.rerender('3312c812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/profile/startupProfile/founderProfileCard.vue"
export default component.exports